import {Injectable} from '@angular/core';
import {UserInfoService} from './user-info.service';
import {LoginService} from './api/login.service';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Permission} from '../pages/settings/permission/permission.model';
import {resolve} from '@angular-devkit/core';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
per = null;
    constructor(
        private router: Router,
        private loginService: LoginService,
        private userInfoService: UserInfoService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        return this.checkLogin(url);

     /*      var userInfo: Permission;
            this.userInfoService.permission(this.per).then((resp) => {
                userInfo = resp;
                let userPerm = userInfo.name && userInfo.name.length > 0 ? userInfo.name[0].toUpperCase() : '';
                let perm = route && route.data["perm"] && route.data["perm"].length > 0 ? route.data["perm"].map(xx => xx.toUpperCase()) : null;

                if (perm == null || perm.indexOf(userPerm) != -1) resp(true);
                else {
                    resp(false);
                    this.router.navigate(['auth/login']);
                }
            })*/
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    checkLogin(url: string): boolean {
        if (this.userInfoService.isLoggedIn()) {
            return true;
        }
        console.log('User is not logged - This routing guard prvents redirection to any routes that needs logging.');

        // Store the original url in login service and then redirect to login page
        this.loginService.landingPage = url;
        this.router.navigate(['auth/login']);
        return false;
    }
}
